"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagEvaluationDetailsBuilder = exports.AllocationEvaluationCode = exports.flagEvaluationCodes = void 0;
const interfaces_1 = require("./interfaces");
exports.flagEvaluationCodes = [
    'MATCH',
    'FLAG_UNRECOGNIZED_OR_DISABLED',
    'TYPE_MISMATCH',
    'ASSIGNMENT_ERROR',
    'DEFAULT_ALLOCATION_NULL',
    'NO_ACTIONS_SUPPLIED_FOR_BANDIT',
    'BANDIT_ERROR',
];
var AllocationEvaluationCode;
(function (AllocationEvaluationCode) {
    AllocationEvaluationCode["UNEVALUATED"] = "UNEVALUATED";
    AllocationEvaluationCode["MATCH"] = "MATCH";
    AllocationEvaluationCode["BEFORE_START_TIME"] = "BEFORE_START_TIME";
    AllocationEvaluationCode["TRAFFIC_EXPOSURE_MISS"] = "TRAFFIC_EXPOSURE_MISS";
    AllocationEvaluationCode["AFTER_END_TIME"] = "AFTER_END_TIME";
    AllocationEvaluationCode["FAILING_RULE"] = "FAILING_RULE";
})(AllocationEvaluationCode || (exports.AllocationEvaluationCode = AllocationEvaluationCode = {}));
class FlagEvaluationDetailsBuilder {
    constructor(environmentName, allocations, configFetchedAt, configPublishedAt) {
        this.environmentName = environmentName;
        this.allocations = allocations;
        this.configFetchedAt = configFetchedAt;
        this.configPublishedAt = configPublishedAt;
        this.variationKey = null;
        this.variationValue = null;
        this.matchedRule = null;
        this.matchedAllocation = null;
        this.unmatchedAllocations = [];
        this.addUnmatchedAllocation = (allocationEvaluation) => {
            this.unmatchedAllocations.push(allocationEvaluation);
        };
        this.setNone = () => {
            this.variationKey = null;
            this.variationValue = null;
            this.matchedRule = null;
            this.matchedAllocation = null;
            return this;
        };
        this.setMatch = (indexPosition, variation, allocation, matchedRule, expectedVariationType) => {
            this.variationKey = variation.key;
            // variation.value needs to be parsed into a JSON object if the variation type is JSON
            // or else it will just remain a string
            this.variationValue =
                expectedVariationType === interfaces_1.VariationType.JSON && typeof variation.value === 'string'
                    ? JSON.parse(variation.value)
                    : variation.value;
            this.matchedRule = matchedRule;
            this.matchedAllocation = {
                key: allocation.key,
                allocationEvaluationCode: AllocationEvaluationCode.MATCH,
                orderPosition: indexPosition + 1, // orderPosition is 1-indexed to match UI
            };
            return this;
        };
        this.buildForNoneResult = (flagEvaluationCode, flagEvaluationDescription) => this.setNone().build(flagEvaluationCode, flagEvaluationDescription);
        this.build = (flagEvaluationCode, flagEvaluationDescription) => ({
            environmentName: this.environmentName,
            flagEvaluationCode,
            flagEvaluationDescription,
            variationKey: this.variationKey,
            variationValue: this.variationValue,
            banditKey: null, // gets set downstream if applicable
            banditAction: null, // gets set downstream if applicable
            configFetchedAt: this.configFetchedAt,
            configPublishedAt: this.configPublishedAt,
            matchedRule: this.matchedRule,
            matchedAllocation: this.matchedAllocation,
            unmatchedAllocations: this.unmatchedAllocations,
            unevaluatedAllocations: this.calculateUnevaluatedAllocations(),
        });
        this.gracefulBuild = (flagEvaluationCode, flagEvaluationDescription) => {
            try {
                return this.build(flagEvaluationCode, flagEvaluationDescription);
            }
            catch (err) {
                return null;
            }
        };
        this.calculateUnevaluatedAllocations = () => {
            const unevaluatedStartIndex = this.matchedAllocation
                ? this.unmatchedAllocations.length + 1
                : this.unmatchedAllocations.length;
            const unevaluatedStartOrderPosition = unevaluatedStartIndex + 1; // orderPosition is 1-indexed to match UI
            return this.allocations.slice(unevaluatedStartIndex).map((allocation, i) => ({
                key: allocation.key,
                allocationEvaluationCode: AllocationEvaluationCode.UNEVALUATED,
                orderPosition: unevaluatedStartOrderPosition + i,
            }));
        };
        this.setNone();
    }
}
exports.FlagEvaluationDetailsBuilder = FlagEvaluationDetailsBuilder;
//# sourceMappingURL=flag-evaluation-details-builder.js.map